import React from 'react';
import styles from './LoadingIcon.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

function LoadingIcon({ className }) {
  return (
    <div className={cx('lds-css', className)}>
      <div className={cx('lds-rolling')}>
        <div />
      </div>
    </div>
  );
}

export default LoadingIcon;
